import React from "react";
import FileTypeModal from "./FileTypeModal";
import { getFileExtension, getFileName, resolveFileUrl } from "./fileUtils";

const FallbackFileViewer = ({ file, open, onClose, projectId }) => {
  const fileName = getFileName(file);
  const extension = getFileExtension(file);
  const fileUrl = resolveFileUrl(file, projectId);

  return (
    <FileTypeModal open={open} onClose={onClose} title={fileName || "File"}>
      <div className="space-y-4">
        <p className="text-sm">
          Preview is not available for <strong>.{extension || "unknown"}</strong> in-browser.
        </p>
        <p className="text-sm">You can still open or download this file.</p>
        <div className="flex gap-3">
          <a
            href={fileUrl}
            target="_blank"
            rel="noreferrer"
            className="rounded bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            Open File
          </a>
          <a
            href={fileUrl}
            download={fileName}
            className="rounded bg-gray-700 px-4 py-2 text-sm font-semibold text-white hover:bg-gray-800"
          >
            Download
          </a>
        </div>
      </div>
    </FileTypeModal>
  );
};

export default FallbackFileViewer;

